import React, {Fragment, useContext, useState} from 'react';
import {Button, Col, Container, Media, Row} from "reactstrap";
import {Formik} from "formik";
import localized from "../../i18n";
import {Link, useNavigate} from "react-router-dom";
import OtpInput from "react-otp-input";
import axios from "axios";
import {handleError, showsuccesToast} from "../HandleError";
import Cookie from "../../utils/cookie";
import cookie from "../../utils/cookie";
import authContext from "../../AuthProvider/authContext";

const VerifyOtp = () => {
    const [data, setData] = useState();
    let email = Cookie.get("credentials");
    const navigate = useNavigate();
    const {updateAuth} = useContext(authContext);
    const [otp, setOtp] = useState("");
    const handleStateChange = (value) => {
        setOtp(value);
    };

    // if (Cookie.get("credentials") === ""){
    //     navigate("/login");
    // }
    const resendOtp = () => {
        axios.post("/api/resend-otp", {email: email})
            .then((res) => {
                setData(res.data.data)
                const data = res.data.data.language
                updateAuth({lang:data});
                localStorage.setItem('lang', data)
                localized.setLanguage(localStorage.getItem('lang'));
                showsuccesToast(localized.otp_resend_successfully)
            })
            .catch((err) => handleError(err))

    }


    const verifyOtp = () => {
        axios.post("/api/verify-email", {email: email, otp: otp})
            .then((response) => {
                const token = response.data.data.token;
                axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
                showsuccesToast(localized.login_successfully);
                navigate("/dashboard");
                cookie.save('jwt', token, {
                    path: '/',
                    days: 7,
                });
            })
            .catch((err) => {
                handleError(err);
            })
    }

    return (
        <div>
            <Container fluid={true} className="p-0">
                <Row className="m-0">
                    <Col xs="12" className="p-0">
                        <div className="login-card auth-login">
                            <div>
                                <div className="login-main login-tab">
                                    <Formik
                                        initialValues={{}}
                                        onSubmit={verifyOtp}
                                    >
                                        {props => {
                                            const {handleSubmit,isSubmitting} = props;
                                            return (
                                                <form onSubmit={handleSubmit} className="theme-form">
                                                    <Fragment>
                                                        <h3 className={"text-center mb-4"}>
                                                            {localized.we_just_emailed_you_a_code_at} {email}
                                                            <br/>
                                                            {localized.enter_it_here_to_verify_your_account}
                                                        </h3>
                                                    </Fragment>
                                                    <div className="otp-input">
                                                        <OtpInput
                                                            value={otp}
                                                            onChange={(e) => handleStateChange(e)}
                                                            numInputs={4}
                                                            separator={<span>-</span>}
                                                        />
                                                    </div>
                                                    <div className="text-end mt-3">
                                                        {otp.length != 4 ?
                                                            <Button disabled
                                                                    type="submit"
                                                                    color={"primary w-100"}
                                                                    className={"btn-block"}
                                                            >
                                                                {data ? localized.Loading :localized.verify_account}
                                                            </Button> :
                                                            <Button
                                                                type="submit"
                                                                color={"primary w-100"}
                                                                className={"btn-block"}
                                                            >
                                                                {data ? localized.Loading :localized.verify_account}
                                                            </Button>}
                                                    </div>
                                                </form>
                                            )
                                        }}
                                    </Formik>
                                    <p className="mt-4 mb-0 text-center">
                                        {localized.did_not_receive_your_code}
                                        <span onClick={resendOtp}
                                              style={{color: "blue", cursor: "pointer"}}> {localized.resend_code}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default VerifyOtp;